// src/components/ui/LanguageSwitcher.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("de") ? "de" : "en";

  const btn =
    "inline-flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-md border border-transparent hover:border-secondary/60 transition focus:outline-none";
  const active =
    "ring-2 ring-secondary/70 ring-offset-1 ring-offset-transparent";

  const setLang = (code) => {
    if ((code === "de" && lang !== "de") || (code === "en" && lang !== "en")) {
      i18n.changeLanguage(code);
    }
  };

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      {/* English */}
      <button
        type="button"
        onClick={() => setLang("en")}
        className={`${btn} ${lang === "en" ? active : ""}`}
        aria-label="Switch to English"
        title="English"
      >
        <img
          src="/assets/flags/enn.png"
          alt="English"
          className="w-5 h-3 sm:w-6 sm:h-4 object-cover rounded-sm"
          draggable="false"
        />
        <span className="text-xs sm:text-sm text-white font-medium">EN</span>
      </button>

      {/* German */}
      <button
        type="button"
        onClick={() => setLang("de")}
        className={`${btn} ${lang === "de" ? active : ""}`}
        aria-label="Auf Deutsch umschalten"
        title="Deutsch"
      >
        <img
          src="/assets/flags/germany.png"
          alt="Deutsch"
          className="w-5 h-3 sm:w-6 sm:h-4 object-cover rounded-sm"
          draggable="false"
        />
        <span className="text-xs sm:text-sm text-white font-medium">DE</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
